import React from 'react';
import PropTypes from 'prop-types';
import { safeRest } from '@wds/utils';
import { useTheme } from 'react-jss';

import useStyles from './useStyles';

const Label = ({ children, htmlFor, muted, plain, ...rest }) => {
  const theme = useTheme();
  const { wrenchLabel } = useStyles({ theme, muted, plain });

  return (
    <label className={wrenchLabel} htmlFor={htmlFor} {...safeRest(rest)}>
      {children}
    </label>
  );
};

Label.propTypes = {
  children: PropTypes.string.isRequired,
  htmlFor: PropTypes.string.isRequired,
  muted: PropTypes.bool,
  plain: PropTypes.bool,
};

Label.defaultProps = {
  muted: false,
  plain: false,
};

export default Label;
